import { render } from "./AttendanceDefinitionSettings.vue?vue&type=template&id=08b199a0"
import script from "./AttendanceDefinitionSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceDefinitionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__